"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeAsyncCard = require("crm_ui/sidebar/makeAsyncCard");

var propTypes = {
  isUngatedForGraphQL: _propTypes.default.bool
};

function ProfileWebsiteActivityWrapper(props) {
  var WebsiteActivityCard = props.isUngatedForGraphQL ? (0, _makeAsyncCard.makeAsyncCard)({
    chunkName: 'sidebar-website-activity-graphql',
    loader: function loader() {
      return import(
      /* webpackChunkName: "sidebar-website-activity-graphql" */
      'crm_ui/profile/sidebar/contacts/ProfileWebsiteActivity');
    }
  }) : (0, _makeAsyncCard.makeAsyncCard)({
    chunkName: 'sidebar-website-activity-legacy',
    loader: function loader() {
      return import(
      /* webpackChunkName: "sidebar-website-activity-legacy" */
      'crm_ui/profile/sidebar/contacts/ProfileWebsiteActivityContainer');
    }
  });
  return _react.default.createElement(WebsiteActivityCard, props);
}

ProfileWebsiteActivityWrapper.propTypes = propTypes;
var _default = ProfileWebsiteActivityWrapper;
exports.default = _default;
module.exports = exports.default;